import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { ErrorDialogService } from '../services/error-dialog.service';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(
    public translate: TranslateService,
    public router: Router,
    public errorDialogService: ErrorDialogService,
    public toastrService: ToastrService,
    public authenticationService: AuthenticationService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let loginToken: any = localStorage.getItem('token');

    if (loginToken) {
      try {
        // If token is stored as JSON, parse it
        const tokenData = JSON.parse(loginToken);

        //Check expiry if your token has `expires_in` field
        // if (tokenData.expires_in && Date.now() > tokenData.expires_in) {
        //   console.log('Token expired');
        //   this.toastrService.error(this.translate.instant('common.error_messages.message2'));
        //   this.handleLogout();
        // }

        request = request.clone({
          headers: request.headers.set('Authorization', `Bearer ${tokenData.token || loginToken}`)
        });
      } catch {
        // If plain token (not JSON), use directly
        request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${loginToken}`) });
      }
    }

    if (!request.headers.has('Content-Type') && !(request.body instanceof FormData)) {
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    }

    request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

    if (request.url.includes("generate")) {
      request = request.clone({ headers: request.headers.set('Accept', 'application/pdf') });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => event),
      catchError((error: HttpErrorResponse) => {
        let errorMessages: string[] = [];

        switch (error.status) {
          case 401:
            // Unauthorized → token expired or invalid
            this.toastrService.error(this.translate.instant('common.error_messages.message2'));
            this.handleLogout();
            break;
          case 403:
            this.toastrService.error(
              this.translate.instant('common.error_messages.message1'),
              this.translate.instant('common.errors_keys.key4')
            );
            break;
          case 404:
            this.toastrService.error(
              this.translate.instant('common.error_messages.message4'),
              this.translate.instant('common.errors_keys.key5')
            );
            break;
          case 422:
            if (error.error.error) {
              this.toastrService.error(error.error.error, this.translate.instant('common.errors_keys.key6'));
            } else {
              for (let iRow in error.error.errors) {
                for (let jRow in error.error.errors[iRow]) {
                  errorMessages.push(error.error.errors[iRow][jRow]);
                }
              }
              this.errorDialogService.openDialog(error, errorMessages);
            }
            break;
          case 500:
            errorMessages.push(error.error.message);
            this.toastrService.error(error.error.error, this.translate.instant('common.error_messages.message5'));
            break;
          default:
            break;
        }
        return throwError(error);
      })
    );
  }

  private handleLogout() {
    this.authenticationService.logout(); // Clear local storage/session
    this.router.navigate(['/login']); // Redirect to login
  }
}


// 	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
// 	const token = this.authenticationService.currentTokenValue;

// 	// Attach JWT token if available
// 	if (token) {
// 		request = request.clone({
// 			headers: request.headers.set('Authorization', `Bearer ${token}`)
// 		});
// 	}

// 	// Set default Content-Type if not present
// 	if (!request.headers.has('Content-Type')) {
// 		request = request.clone({
// 			headers: request.headers.set('Content-Type', 'application/json')
// 		});
// 	}

// 	// Always set Accept header
// 	request = request.clone({
// 		headers: request.headers.set('Accept', 'application/json')
// 	});

// 	return next.handle(request).pipe(
// 		map((event: HttpEvent<any>) => {
// 			return event;
// 		}),
// 		catchError((error: HttpErrorResponse) => {
// 			let errorMessages = [];

// 			switch (error.status) {
// 				case 400:
// 					if (error.error && error.error.error) {
// 						this.toastrService.error(error.error.error, this.translate.instant('common.errors_keys.key2'));
// 					}
// 					break;
// 				case 401:
// 					this.authenticationService.logout(false);
// 					break;
// 				case 403:
// 					this.toastrService.error(this.translate.instant('common.error_messages.message1'), this.translate.instant('common.errors_keys.key4'));
// 					break;
// 				case 404:
// 					this.toastrService.error(this.translate.instant('common.error_messages.message4'), this.translate.instant('common.errors_keys.key5'));
// 					break;
// 				case 422:
// 					if (error.error && error.error.error) {
// 						this.toastrService.error(error.error.error, this.translate.instant('common.errors_keys.key6'));
// 					} else if  (error.error && error.error.error) {
// 						for (let iRow in error.error.errors) {
// 							for (let jRow in error.error.errors[iRow]) {
// 								errorMessages.push(error.error.errors[iRow][jRow]);
// 							}
// 						}
// 						this.errorDialogService.openDialog(error, errorMessages);
// 					}
// 					break;
// 				case 500:
// 				if (error.error && error.error.error) {
// 						this.toastrService.error(error.error.error, this.translate.instant('common.error_messages.message5'));
// 					}
// 					break;
// 			}

// 			return throwError(error);
// 		})
// 	);
// }

